var map = {
	"./backhoe_black.svg": 975,
	"./backhoe_blue.svg": 976,
	"./backhoe_gray.svg": 977,
	"./backhoe_green.svg": 978,
	"./backhoe_indigo.svg": 979,
	"./backhoe_navy.svg": 980,
	"./backhoe_orange.svg": 981,
	"./backhoe_pink.svg": 982,
	"./backhoe_purple.svg": 983,
	"./backhoe_red.svg": 984,
	"./backhoe_salmon.svg": 985,
	"./backhoe_tomato.svg": 986,
	"./backhoe_turquoise.svg": 987,
	"./backhoe_white.svg": 988,
	"./backhoe_yellow.svg": 989,
	"./bulldozer_black.svg": 990,
	"./bulldozer_blue.svg": 991,
	"./bulldozer_gray.svg": 992,
	"./bulldozer_green.svg": 993,
	"./bulldozer_indigo.svg": 994,
	"./bulldozer_navy.svg": 995,
	"./bulldozer_orange.svg": 996,
	"./bulldozer_pink.svg": 997,
	"./bulldozer_purple.svg": 998,
	"./bulldozer_red.svg": 999,
	"./bulldozer_salmon.svg": 1000,
	"./bulldozer_tomato.svg": 1001,
	"./bulldozer_turquoise.svg": 1002,
	"./bulldozer_white.svg": 1003,
	"./bulldozer_yellow.svg": 1004,
	"./camper_black.svg": 1005,
	"./camper_blue.svg": 1006,
	"./camper_gray.svg": 1007,
	"./camper_green.svg": 1008,
	"./camper_indigo.svg": 1009,
	"./camper_navy.svg": 1010,
	"./camper_orange.svg": 1011,
	"./camper_pink.svg": 1012,
	"./camper_purple.svg": 1013,
	"./camper_red.svg": 1014,
	"./camper_salmon.svg": 1015,
	"./camper_tomato.svg": 1016,
	"./camper_turquoise.svg": 1017,
	"./camper_white.svg": 1018,
	"./camper_yellow.svg": 1019,
	"./cementTruck_black.svg": 1020,
	"./cementTruck_blue.svg": 1021,
	"./cementTruck_gray.svg": 1022,
	"./cementTruck_green.svg": 1023,
	"./cementTruck_indigo.svg": 1024,
	"./cementTruck_navy.svg": 1025,
	"./cementTruck_orange.svg": 1026,
	"./cementTruck_pink.svg": 1027,
	"./cementTruck_purple.svg": 1028,
	"./cementTruck_red.svg": 1029,
	"./cementTruck_salmon.svg": 1030,
	"./cementTruck_tomato.svg": 1031,
	"./cementTruck_turquoise.svg": 1032,
	"./cementTruck_white.svg": 1033,
	"./cementTruck_yellow.svg": 1034,
	"./circle_black.svg": 1035,
	"./circle_blue.svg": 1036,
	"./circle_gray.svg": 1037,
	"./circle_green.svg": 1038,
	"./circle_indigo.svg": 1039,
	"./circle_navy.svg": 1040,
	"./circle_orange.svg": 1041,
	"./circle_pink.svg": 1042,
	"./circle_purple.svg": 1043,
	"./circle_red.svg": 1044,
	"./circle_salmon.svg": 1045,
	"./circle_tomato.svg": 1046,
	"./circle_turquoise.svg": 1047,
	"./circle_white.svg": 1048,
	"./circle_yellow.svg": 1049,
	"./crane_black.svg": 1050,
	"./crane_blue.svg": 1051,
	"./crane_gray.svg": 1052,
	"./crane_green.svg": 1053,
	"./crane_indigo.svg": 1054,
	"./crane_navy.svg": 1055,
	"./crane_orange.svg": 1056,
	"./crane_pink.svg": 1057,
	"./crane_purple.svg": 1058,
	"./crane_red.svg": 1059,
	"./crane_salmon.svg": 1060,
	"./crane_tomato.svg": 1061,
	"./crane_turquoise.svg": 1062,
	"./crane_white.svg": 1063,
	"./crane_yellow.svg": 1064,
	"./deliveryVan_black.svg": 1065,
	"./deliveryVan_blue.svg": 1066,
	"./deliveryVan_gray.svg": 1067,
	"./deliveryVan_green.svg": 1068,
	"./deliveryVan_indigo.svg": 1069,
	"./deliveryVan_navy.svg": 1070,
	"./deliveryVan_orange.svg": 1071,
	"./deliveryVan_pink.svg": 1072,
	"./deliveryVan_purple.svg": 1073,
	"./deliveryVan_red.svg": 1074,
	"./deliveryVan_salmon.svg": 1075,
	"./deliveryVan_tomato.svg": 1076,
	"./deliveryVan_turquoise.svg": 1077,
	"./deliveryVan_white.svg": 1078,
	"./deliveryVan_yellow.svg": 1079,
	"./dumpTruck_black.svg": 1080,
	"./dumpTruck_blue.svg": 1081,
	"./dumpTruck_gray.svg": 1082,
	"./dumpTruck_green.svg": 1083,
	"./dumpTruck_indigo.svg": 1084,
	"./dumpTruck_navy.svg": 1085,
	"./dumpTruck_orange.svg": 1086,
	"./dumpTruck_pink.svg": 1087,
	"./dumpTruck_purple.svg": 1088,
	"./dumpTruck_red.svg": 1089,
	"./dumpTruck_salmon.svg": 1090,
	"./dumpTruck_tomato.svg": 1091,
	"./dumpTruck_turquoise.svg": 1092,
	"./dumpTruck_white.svg": 1093,
	"./dumpTruck_yellow.svg": 1094,
	"./flatBedTruck_black.svg": 1095,
	"./flatBedTruck_blue.svg": 1096,
	"./flatBedTruck_gray.svg": 1097,
	"./flatBedTruck_green.svg": 1098,
	"./flatBedTruck_indigo.svg": 1099,
	"./flatBedTruck_navy.svg": 1100,
	"./flatBedTruck_orange.svg": 1101,
	"./flatBedTruck_pink.svg": 1102,
	"./flatBedTruck_purple.svg": 1103,
	"./flatBedTruck_red.svg": 1104,
	"./flatBedTruck_salmon.svg": 1105,
	"./flatBedTruck_tomato.svg": 1106,
	"./flatBedTruck_turquoise.svg": 1107,
	"./flatBedTruck_white.svg": 1108,
	"./flatBedTruck_yellow.svg": 1109,
	"./garbageTruck_black.svg": 1110,
	"./garbageTruck_blue.svg": 1111,
	"./garbageTruck_gray.svg": 1112,
	"./garbageTruck_green.svg": 1113,
	"./garbageTruck_indigo.svg": 1114,
	"./garbageTruck_navy.svg": 1115,
	"./garbageTruck_orange.svg": 1116,
	"./garbageTruck_pink.svg": 1117,
	"./garbageTruck_purple.svg": 1118,
	"./garbageTruck_red.svg": 1119,
	"./garbageTruck_salmon.svg": 1120,
	"./garbageTruck_tomato.svg": 1121,
	"./garbageTruck_turquoise.svg": 1122,
	"./garbageTruck_white.svg": 1123,
	"./garbageTruck_yellow.svg": 1124,
	"./horizontalRectangle_black.svg": 1125,
	"./horizontalRectangle_blue.svg": 1126,
	"./horizontalRectangle_gray.svg": 1127,
	"./horizontalRectangle_green.svg": 1128,
	"./horizontalRectangle_indigo.svg": 1129,
	"./horizontalRectangle_navy.svg": 1130,
	"./horizontalRectangle_orange.svg": 1131,
	"./horizontalRectangle_pink.svg": 1132,
	"./horizontalRectangle_purple.svg": 1133,
	"./horizontalRectangle_red.svg": 1134,
	"./horizontalRectangle_salmon.svg": 1135,
	"./horizontalRectangle_tomato.svg": 1136,
	"./horizontalRectangle_turquoise.svg": 1137,
	"./horizontalRectangle_white.svg": 1138,
	"./horizontalRectangle_yellow.svg": 1139,
	"./largeDeliveryTruck_black.svg": 1140,
	"./largeDeliveryTruck_blue.svg": 1141,
	"./largeDeliveryTruck_gray.svg": 1142,
	"./largeDeliveryTruck_green.svg": 1143,
	"./largeDeliveryTruck_indigo.svg": 1144,
	"./largeDeliveryTruck_navy.svg": 1145,
	"./largeDeliveryTruck_orange.svg": 1146,
	"./largeDeliveryTruck_pink.svg": 1147,
	"./largeDeliveryTruck_purple.svg": 1148,
	"./largeDeliveryTruck_red.svg": 1149,
	"./largeDeliveryTruck_salmon.svg": 1150,
	"./largeDeliveryTruck_tomato.svg": 1151,
	"./largeDeliveryTruck_turquoise.svg": 1152,
	"./largeDeliveryTruck_white.svg": 1153,
	"./largeDeliveryTruck_yellow.svg": 1154,
	"./lawnMower_black.svg": 1155,
	"./lawnMower_blue.svg": 1156,
	"./lawnMower_gray.svg": 1157,
	"./lawnMower_green.svg": 1158,
	"./lawnMower_indigo.svg": 1159,
	"./lawnMower_navy.svg": 1160,
	"./lawnMower_orange.svg": 1161,
	"./lawnMower_pink.svg": 1162,
	"./lawnMower_purple.svg": 1163,
	"./lawnMower_red.svg": 1164,
	"./lawnMower_salmon.svg": 1165,
	"./lawnMower_tomato.svg": 1166,
	"./lawnMower_turquoise.svg": 1167,
	"./lawnMower_white.svg": 1168,
	"./lawnMower_yellow.svg": 1169,
	"./minivan_black.svg": 1170,
	"./minivan_blue.svg": 1171,
	"./minivan_gray.svg": 1172,
	"./minivan_green.svg": 1173,
	"./minivan_indigo.svg": 1174,
	"./minivan_navy.svg": 1175,
	"./minivan_orange.svg": 1176,
	"./minivan_pink.svg": 1177,
	"./minivan_purple.svg": 1178,
	"./minivan_red.svg": 1179,
	"./minivan_salmon.svg": 1180,
	"./minivan_tomato.svg": 1181,
	"./minivan_turquoise.svg": 1182,
	"./minivan_white.svg": 1183,
	"./minivan_yellow.svg": 1184,
	"./motorhome_black.svg": 1185,
	"./motorhome_blue.svg": 1186,
	"./motorhome_gray.svg": 1187,
	"./motorhome_green.svg": 1188,
	"./motorhome_indigo.svg": 1189,
	"./motorhome_navy.svg": 1190,
	"./motorhome_orange.svg": 1191,
	"./motorhome_pink.svg": 1192,
	"./motorhome_purple.svg": 1193,
	"./motorhome_red.svg": 1194,
	"./motorhome_salmon.svg": 1195,
	"./motorhome_tomato.svg": 1196,
	"./motorhome_turquoise.svg": 1197,
	"./motorhome_white.svg": 1198,
	"./motorhome_yellow.svg": 1199,
	"./paver_black.svg": 1200,
	"./paver_blue.svg": 1201,
	"./paver_gray.svg": 1202,
	"./paver_green.svg": 1203,
	"./paver_indigo.svg": 1204,
	"./paver_navy.svg": 1205,
	"./paver_orange.svg": 1206,
	"./paver_pink.svg": 1207,
	"./paver_purple.svg": 1208,
	"./paver_red.svg": 1209,
	"./paver_salmon.svg": 1210,
	"./paver_tomato.svg": 1211,
	"./paver_turquoise.svg": 1212,
	"./paver_white.svg": 1213,
	"./paver_yellow.svg": 1214,
	"./pickup_black.svg": 1215,
	"./pickup_blue.svg": 1216,
	"./pickup_gray.svg": 1217,
	"./pickup_green.svg": 1218,
	"./pickup_indigo.svg": 1219,
	"./pickup_navy.svg": 1220,
	"./pickup_orange.svg": 1221,
	"./pickup_pink.svg": 1222,
	"./pickup_purple.svg": 1223,
	"./pickup_red.svg": 1224,
	"./pickup_salmon.svg": 1225,
	"./pickup_tomato.svg": 1226,
	"./pickup_turquoise.svg": 1227,
	"./pickup_white.svg": 1228,
	"./pickup_yellow.svg": 1229,
	"./policeCar_black.svg": 1230,
	"./policeCar_blue.svg": 1231,
	"./policeCar_gray.svg": 1232,
	"./policeCar_green.svg": 1233,
	"./policeCar_indigo.svg": 1234,
	"./policeCar_navy.svg": 1235,
	"./policeCar_orange.svg": 1236,
	"./policeCar_pink.svg": 1237,
	"./policeCar_purple.svg": 1238,
	"./policeCar_red.svg": 1239,
	"./policeCar_salmon.svg": 1240,
	"./policeCar_tomato.svg": 1241,
	"./policeCar_turquoise.svg": 1242,
	"./policeCar_white.svg": 1243,
	"./policeCar_yellow.svg": 1244,
	"./sedan_black.svg": 1245,
	"./sedan_blue.svg": 1246,
	"./sedan_gray.svg": 1247,
	"./sedan_green.svg": 1248,
	"./sedan_indigo.svg": 1249,
	"./sedan_navy.svg": 1250,
	"./sedan_orange.svg": 1251,
	"./sedan_pink.svg": 1252,
	"./sedan_purple.svg": 1253,
	"./sedan_red.svg": 1254,
	"./sedan_salmon.svg": 1255,
	"./sedan_tomato.svg": 1256,
	"./sedan_turquoise.svg": 1257,
	"./sedan_white.svg": 1258,
	"./sedan_yellow.svg": 1259,
	"./semiTractorNoTrailer_black.svg": 1260,
	"./semiTractorNoTrailer_blue.svg": 1261,
	"./semiTractorNoTrailer_gray.svg": 1262,
	"./semiTractorNoTrailer_green.svg": 1263,
	"./semiTractorNoTrailer_indigo.svg": 1264,
	"./semiTractorNoTrailer_navy.svg": 1265,
	"./semiTractorNoTrailer_orange.svg": 1266,
	"./semiTractorNoTrailer_pink.svg": 1267,
	"./semiTractorNoTrailer_purple.svg": 1268,
	"./semiTractorNoTrailer_red.svg": 1269,
	"./semiTractorNoTrailer_salmon.svg": 1270,
	"./semiTractorNoTrailer_tomato.svg": 1271,
	"./semiTractorNoTrailer_turquoise.svg": 1272,
	"./semiTractorNoTrailer_white.svg": 1273,
	"./semiTractorNoTrailer_yellow.svg": 1274,
	"./semiTractorWithTrailer_black.svg": 1275,
	"./semiTractorWithTrailer_blue.svg": 1276,
	"./semiTractorWithTrailer_gray.svg": 1277,
	"./semiTractorWithTrailer_green.svg": 1278,
	"./semiTractorWithTrailer_indigo.svg": 1279,
	"./semiTractorWithTrailer_navy.svg": 1280,
	"./semiTractorWithTrailer_orange.svg": 1281,
	"./semiTractorWithTrailer_pink.svg": 1282,
	"./semiTractorWithTrailer_purple.svg": 1283,
	"./semiTractorWithTrailer_red.svg": 1284,
	"./semiTractorWithTrailer_salmon.svg": 1285,
	"./semiTractorWithTrailer_tomato.svg": 1286,
	"./semiTractorWithTrailer_turquoise.svg": 1287,
	"./semiTractorWithTrailer_white.svg": 1288,
	"./semiTractorWithTrailer_yellow.svg": 1289,
	"./smallDeliveryTruck_black.svg": 1290,
	"./smallDeliveryTruck_blue.svg": 1291,
	"./smallDeliveryTruck_gray.svg": 1292,
	"./smallDeliveryTruck_green.svg": 1293,
	"./smallDeliveryTruck_indigo.svg": 1294,
	"./smallDeliveryTruck_navy.svg": 1295,
	"./smallDeliveryTruck_orange.svg": 1296,
	"./smallDeliveryTruck_pink.svg": 1297,
	"./smallDeliveryTruck_purple.svg": 1298,
	"./smallDeliveryTruck_red.svg": 1299,
	"./smallDeliveryTruck_salmon.svg": 1300,
	"./smallDeliveryTruck_tomato.svg": 1301,
	"./smallDeliveryTruck_turquoise.svg": 1302,
	"./smallDeliveryTruck_white.svg": 1303,
	"./smallDeliveryTruck_yellow.svg": 1304,
	"./suv_black.svg": 1305,
	"./suv_blue.svg": 1306,
	"./suv_gray.svg": 1307,
	"./suv_green.svg": 1308,
	"./suv_indigo.svg": 1309,
	"./suv_navy.svg": 1310,
	"./suv_orange.svg": 1311,
	"./suv_pink.svg": 1312,
	"./suv_purple.svg": 1313,
	"./suv_red.svg": 1314,
	"./suv_salmon.svg": 1315,
	"./suv_tomato.svg": 1316,
	"./suv_turquoise.svg": 1317,
	"./suv_white.svg": 1318,
	"./suv_yellow.svg": 1319,
	"./tankTrailer_black.svg": 1320,
	"./tankTrailer_blue.svg": 1321,
	"./tankTrailer_gray.svg": 1322,
	"./tankTrailer_green.svg": 1323,
	"./tankTrailer_indigo.svg": 1324,
	"./tankTrailer_navy.svg": 1325,
	"./tankTrailer_orange.svg": 1326,
	"./tankTrailer_pink.svg": 1327,
	"./tankTrailer_purple.svg": 1328,
	"./tankTrailer_red.svg": 1329,
	"./tankTrailer_salmon.svg": 1330,
	"./tankTrailer_tomato.svg": 1331,
	"./tankTrailer_turquoise.svg": 1332,
	"./tankTrailer_white.svg": 1333,
	"./tankTrailer_yellow.svg": 1334,
	"./tankTruck_black.svg": 1335,
	"./tankTruck_blue.svg": 1336,
	"./tankTruck_gray.svg": 1337,
	"./tankTruck_green.svg": 1338,
	"./tankTruck_indigo.svg": 1339,
	"./tankTruck_navy.svg": 1340,
	"./tankTruck_orange.svg": 1341,
	"./tankTruck_pink.svg": 1342,
	"./tankTruck_purple.svg": 1343,
	"./tankTruck_red.svg": 1344,
	"./tankTruck_salmon.svg": 1345,
	"./tankTruck_tomato.svg": 1346,
	"./tankTruck_turquoise.svg": 1347,
	"./tankTruck_white.svg": 1348,
	"./tankTruck_yellow.svg": 1349,
	"./taxi_black.svg": 1350,
	"./taxi_blue.svg": 1351,
	"./taxi_gray.svg": 1352,
	"./taxi_green.svg": 1353,
	"./taxi_indigo.svg": 1354,
	"./taxi_navy.svg": 1355,
	"./taxi_orange.svg": 1356,
	"./taxi_pink.svg": 1357,
	"./taxi_purple.svg": 1358,
	"./taxi_red.svg": 1359,
	"./taxi_salmon.svg": 1360,
	"./taxi_tomato.svg": 1361,
	"./taxi_turquoise.svg": 1362,
	"./taxi_white.svg": 1363,
	"./taxi_yellow.svg": 1364,
	"./tractorPlow_black.svg": 1365,
	"./tractorPlow_blue.svg": 1366,
	"./tractorPlow_gray.svg": 1367,
	"./tractorPlow_green.svg": 1368,
	"./tractorPlow_indigo.svg": 1369,
	"./tractorPlow_navy.svg": 1370,
	"./tractorPlow_orange.svg": 1371,
	"./tractorPlow_pink.svg": 1372,
	"./tractorPlow_purple.svg": 1373,
	"./tractorPlow_red.svg": 1374,
	"./tractorPlow_salmon.svg": 1375,
	"./tractorPlow_tomato.svg": 1376,
	"./tractorPlow_turquoise.svg": 1377,
	"./tractorPlow_white.svg": 1378,
	"./tractorPlow_yellow.svg": 1379,
	"./tractor_black.svg": 1380,
	"./tractor_blue.svg": 1381,
	"./tractor_gray.svg": 1382,
	"./tractor_green.svg": 1383,
	"./tractor_indigo.svg": 1384,
	"./tractor_navy.svg": 1385,
	"./tractor_orange.svg": 1386,
	"./tractor_pink.svg": 1387,
	"./tractor_purple.svg": 1388,
	"./tractor_red.svg": 1389,
	"./tractor_salmon.svg": 1390,
	"./tractor_tomato.svg": 1391,
	"./tractor_turquoise.svg": 1392,
	"./tractor_white.svg": 1393,
	"./tractor_yellow.svg": 1394,
	"./trailer_black.svg": 1395,
	"./trailer_blue.svg": 1396,
	"./trailer_gray.svg": 1397,
	"./trailer_green.svg": 1398,
	"./trailer_indigo.svg": 1399,
	"./trailer_navy.svg": 1400,
	"./trailer_orange.svg": 1401,
	"./trailer_pink.svg": 1402,
	"./trailer_purple.svg": 1403,
	"./trailer_red.svg": 1404,
	"./trailer_salmon.svg": 1405,
	"./trailer_tomato.svg": 1406,
	"./trailer_turquoise.svg": 1407,
	"./trailer_white.svg": 1408,
	"./trailer_yellow.svg": 1409,
	"./truck_black.svg": 1410,
	"./truck_blue.svg": 1411,
	"./truck_gray.svg": 1412,
	"./truck_green.svg": 1413,
	"./truck_grey.svg": 1414,
	"./truck_indigo.svg": 1415,
	"./truck_navy.svg": 1416,
	"./truck_orange.svg": 1417,
	"./truck_pink.svg": 1418,
	"./truck_purple.svg": 1419,
	"./truck_red.svg": 1420,
	"./truck_salmon.svg": 1421,
	"./truck_tomato.svg": 1422,
	"./truck_turquoise.svg": 1423,
	"./truck_white.svg": 1424,
	"./truck_yellow.svg": 1425,
	"./vanTrailer_black.svg": 1426,
	"./vanTrailer_blue.svg": 1427,
	"./vanTrailer_gray.svg": 1428,
	"./vanTrailer_green.svg": 1429,
	"./vanTrailer_indigo.svg": 1430,
	"./vanTrailer_navy.svg": 1431,
	"./vanTrailer_orange.svg": 1432,
	"./vanTrailer_pink.svg": 1433,
	"./vanTrailer_purple.svg": 1434,
	"./vanTrailer_red.svg": 1435,
	"./vanTrailer_salmon.svg": 1436,
	"./vanTrailer_tomato.svg": 1437,
	"./vanTrailer_turquoise.svg": 1438,
	"./vanTrailer_white.svg": 1439,
	"./vanTrailer_yellow.svg": 1440,
	"./van_black.svg": 1441,
	"./van_blue.svg": 1442,
	"./van_gray.svg": 1443,
	"./van_green.svg": 1444,
	"./van_indigo.svg": 1445,
	"./van_navy.svg": 1446,
	"./van_orange.svg": 1447,
	"./van_pink.svg": 1448,
	"./van_purple.svg": 1449,
	"./van_red.svg": 1450,
	"./van_salmon.svg": 1451,
	"./van_tomato.svg": 1452,
	"./van_turquoise.svg": 1453,
	"./van_white.svg": 1454,
	"./van_yellow.svg": 1455,
	"./verticalRectangle_black.svg": 1456,
	"./verticalRectangle_blue.svg": 1457,
	"./verticalRectangle_gray.svg": 1458,
	"./verticalRectangle_green.svg": 1459,
	"./verticalRectangle_indigo.svg": 1460,
	"./verticalRectangle_navy.svg": 1461,
	"./verticalRectangle_orange.svg": 1462,
	"./verticalRectangle_pink.svg": 1463,
	"./verticalRectangle_purple.svg": 1464,
	"./verticalRectangle_red.svg": 1465,
	"./verticalRectangle_salmon.svg": 1466,
	"./verticalRectangle_tomato.svg": 1467,
	"./verticalRectangle_turquoise.svg": 1468,
	"./verticalRectangle_white.svg": 1469,
	"./verticalRectangle_yellow.svg": 1470,
	"./workVan_black.svg": 1471,
	"./workVan_blue.svg": 1472,
	"./workVan_gray.svg": 1473,
	"./workVan_green.svg": 1474,
	"./workVan_indigo.svg": 1475,
	"./workVan_navy.svg": 1476,
	"./workVan_orange.svg": 1477,
	"./workVan_pink.svg": 1478,
	"./workVan_purple.svg": 1479,
	"./workVan_red.svg": 1480,
	"./workVan_salmon.svg": 1481,
	"./workVan_tomato.svg": 1482,
	"./workVan_turquoise.svg": 1483,
	"./workVan_white.svg": 1484,
	"./workVan_yellow.svg": 1485,
	"./wrecker_black.svg": 1486,
	"./wrecker_blue.svg": 1487,
	"./wrecker_gray.svg": 1488,
	"./wrecker_green.svg": 1489,
	"./wrecker_indigo.svg": 1490,
	"./wrecker_navy.svg": 1491,
	"./wrecker_orange.svg": 1492,
	"./wrecker_pink.svg": 1493,
	"./wrecker_purple.svg": 1494,
	"./wrecker_red.svg": 1495,
	"./wrecker_salmon.svg": 1496,
	"./wrecker_tomato.svg": 1497,
	"./wrecker_turquoise.svg": 1498,
	"./wrecker_white.svg": 1499,
	"./wrecker_yellow.svg": 1500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 974;